module.exports = __webpack_public_path__ + "img/m-ita.9541a505.webp";